var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExternal = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.0888V17.2812C18 17.5872 17.8784 17.8807 17.662 18.097C17.4457 18.3134 17.1522 18.435 16.8462 18.435H4.15385C3.84782 18.435 3.55434 18.3134 3.33795 18.097C3.12157 17.8807 3 17.5872 3 17.2812V4.58884C3 4.28282 3.12157 3.98934 3.33795 3.77295C3.55434 3.55656 3.84782 3.435 4.15385 3.435H9.34615",
    stroke: "#26AD85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9614 3.435H17.9999V7.47346",
    stroke: "#26AD85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3.435L10.5 10.935",
    stroke: "#26AD85",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/external.550f4ce8.svg";
export { ForwardRef as ReactComponent };